import type { MutationOptions, QueryOptions } from "@apollo/client/core";
import type { GraphQLFormattedError } from "graphql/error/GraphQLError.js";

export interface AppSyncGraphQLError extends GraphQLFormattedError {
	readonly errorType?: string;
	readonly errorInfo?: unknown;
	readonly data?: unknown;
}

export class AppSyncError extends Error {
	constructor(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		public readonly options: QueryOptions<any> | MutationOptions<any, any>,
		public readonly errors: readonly AppSyncGraphQLError[],
	) {
		super(`GraphQL request failed with errors: ${errors.map((error) => error.message).join(", ")}`);
	}
}
